var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 93,
    viewBox: "0 0 104 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.6386 40.0349V88.8871C92.6386 90.8326 91.0187 92.3404 89.2118 92.3404H14.465C12.5411 92.3404 11.0261 90.7599 11.0261 88.8871V40.0349L49.4577 6.68679C50.7453 5.56397 52.6598 5.56396 53.9608 6.67467L92.6399 40.0349H92.6386Z",
    fill: "#C2CCE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7365 16.0705V83.1424C89.7365 84.5748 88.5754 85.7233 87.1574 85.7233H16.506C15.0879 85.7233 13.9268 84.5748 13.9268 83.1424V16.0705C13.9268 14.0753 15.5427 12.4584 17.5366 12.4584H86.1281C88.122 12.4584 89.7379 14.0753 89.7379 16.0705H89.7365Z",
    fill: "#EAF0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6386 40.0349L92.6023 89.3125C92.5081 90.1647 92.0937 90.9092 91.4802 91.4532C91.4452 91.4882 91.4089 91.5124 91.3739 91.5474L51.8324 66.2408L55.9453 63.6034L92.64 40.0349H92.6386Z",
    fill: "#DEE3EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8324 66.2408L12.2908 91.5595C11.7325 91.1395 11.1634 90.2684 11.0611 89.3125C11.0409 60.1164 11.0463 69.204 11.0261 40.0349L47.554 63.5091L51.8324 66.2408Z",
    fill: "#DEE3EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4802 91.4532C91.4802 91.4532 91.4802 91.4559 91.4802 91.4572C90.3877 92.4239 89.3046 92.3162 89.1876 92.3404L14.0385 92.3054C13.312 92.2273 12.6123 91.9055 12.0298 91.3239L47.5539 63.5105L50.0214 61.5785C51.0022 60.8111 52.3799 60.8111 53.3594 61.5785L55.9453 63.6047L91.4815 91.4545L91.4802 91.4532Z",
    fill: "#C2CCE1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.115,
    y: 25.8518,
    width: 5.54588,
    height: 18.6543,
    rx: 2.77294,
    fill: "#33CBCF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1984,
    y: 25.8518,
    width: 5.54588,
    height: 18.6543,
    rx: 2.77294,
    fill: "#33CBCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0297 7.55784C15.5279 7.55784 15.1054 7.16606 15.0731 6.65715L14.7301 1.15883C14.6964 0.629726 15.0987 0.174673 15.6288 0.141015C16.1548 0.107358 16.6123 0.509902 16.6459 1.039L16.989 6.53734C17.0226 7.06644 16.6203 7.52149 16.0903 7.55515C16.0701 7.55515 16.0499 7.5565 16.0297 7.5565V7.55784Z",
    fill: "#F6A019"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3005 16.1742C96.3005 15.6723 96.6923 15.2499 97.2012 15.2176L102.7 14.8745C103.229 14.8409 103.684 15.2432 103.717 15.7733C103.751 16.2993 103.348 16.7567 102.819 16.7904L97.321 17.1335C96.7919 17.1671 96.3369 16.7648 96.3032 16.2347C96.3032 16.2145 96.3019 16.1944 96.3019 16.1742L96.3005 16.1742Z",
    fill: "#F6A019"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75372 10.2559L4.86145 6.36099C4.48743 5.98671 4.48743 5.37818 4.86145 5.00391C5.23547 4.62963 5.8436 4.62828 6.21762 5.00391L10.1099 8.89878C10.4839 9.27306 10.4839 9.88159 10.1099 10.2559C9.73317 10.6328 9.12639 10.6288 8.75372 10.2559Z",
    fill: "#F6A019"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6024 8.89823L97.4973 5.00596C97.8716 4.63194 98.4801 4.63194 98.8544 5.00596C99.2287 5.37999 99.23 5.98811 98.8544 6.36214L94.9595 10.2544C94.5853 10.6284 93.9767 10.6284 93.6024 10.2544C93.2255 9.87769 93.2295 9.27091 93.6024 8.89823Z",
    fill: "#F6A019"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45574 17.1395C6.43556 17.1395 6.41538 17.1395 6.3952 17.1382L0.900547 16.7949C0.371802 16.7612 -0.0304742 16.3062 0.00181555 15.7771C0.0354508 15.248 0.514416 14.8508 1.01894 14.8791L6.51359 15.2224C7.04234 15.256 7.44462 15.7111 7.41233 16.2402C7.38004 16.7491 6.95892 17.1409 6.45574 17.1409V17.1395Z",
    fill: "#F6A019"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7188 6.60024C86.7188 6.58006 86.7188 6.55988 86.7202 6.5397L87.0635 1.04505C87.0971 0.516302 87.5522 0.114026 88.0813 0.146316C88.6104 0.179951 89.0076 0.658916 88.9793 1.16344L88.636 6.65809C88.6023 7.18684 88.1473 7.58912 87.6182 7.55683C87.1093 7.52454 86.7175 7.10343 86.7175 6.60024L86.7188 6.60024Z",
    fill: "#F6A019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseSubscription);
export default __webpack_public_path__ + "static/media/pause-subscription.fb13a88be2752f020f47ed9722331796.svg";
export { ForwardRef as ReactComponent };